.img{vertical-align:middle}
/*# sourceMappingURL=floating-svg.component-BRKVX3DP.css.map */
